import { Form } from '@mairistem/composants';
import { MULTI } from '@mairistem/comptabilite';
import { Combobox, Panel } from '@mairistem/finances-utils';
import React from 'react';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const CompteDeTiersComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (_e, { name, value }) =>
		onChange?.({ [name]: value }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Field
					control={Combobox}
					data-testid="compteDeTiersDropdown"
					fluid
					key="identifiantCompteTiers"
					label="Code - libellé"
					name="identifiantCompteTiers"
					onChange={handleChange}
					options={data?.comptesDeTiers}
					placeholder={data?.identifiantCompteTiers === MULTI ? MULTI : ''}
					search
					selection
					value={data?.identifiantCompteTiers ?? null}
				/>
			</Form>
		</Panel>
	);
};

export default CompteDeTiersComponent;
